export type Cue = {
  start: number
  end: number
  text: string
  id: string
}

type StoreState = {
  activeChaptersId: number | null
  cues: Cue[]
  currentCueId: string | null
  chaptersScreenOpen: boolean
  wasPlayingWhenOpened: boolean
}

const defaults: StoreState = {
  activeChaptersId: null,
  cues: [],
  currentCueId: null,
  chaptersScreenOpen: false,
  wasPlayingWhenOpened: false,
}

const state = $state(defaults)

const openChaptersScreen = (isPlaying: boolean) => {
  state.chaptersScreenOpen = true
  state.wasPlayingWhenOpened = isPlaying
}
const reset = () => {
  Object.assign(state, defaults)
}

export default {
  state,
  defaults,
  openChaptersScreen,
  reset,
}
